import React from 'react';
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import AccountCircle from '@material-ui/icons/AccountCircle';
import PeopleIcon from '@material-ui/icons/People';
import AssessmentIcon from '@material-ui/icons/Assessment';

import { Link as RouterLink, Redirect } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  desktopMenuLeft: {
    marginLeft: theme.spacing(3),
  },
  title: {
    marginLeft: 10,
    display: 'none',
    [theme.breakpoints.up('xs')]: { /* change back to sm if really want this hidden for xs */
      display: 'block',
    },
  },
  link: {
    margin: theme.spacing(1),
    '&:hover': {
      color: '#ffffff',
    }
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

const AppBarMenuItem = (props) => {
  const classes = useStyles();

  const { menuId, items, buttonTitle, buttonIcon, subMenuClick, sortByTitle = false } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = event => {
    setAnchorEl(null);
    if (subMenuClick !== undefined) {
      subMenuClick();
    }
  };

  const MenuLink = React.forwardRef((props, ref) => <RouterLink innerRef={ref} {...props} />);

  return (
    <React.Fragment>
      {buttonIcon && (
        <React.Fragment>
          <span color="inherit" aria-controls={menuId} aria-haspopup="true" onClick={handleClick}>
            <IconButton color='inherit'>
              {buttonIcon}
            </IconButton>
            <span>{buttonTitle}</span>
          </span>
        </React.Fragment>
      )}
      {!buttonIcon && (
        <Button endIcon={<KeyboardArrowDownIcon />} aria-controls={menuId} aria-haspopup="true" color="inherit" className={classes.link} onClick={handleClick}>
          { buttonTitle }
        </Button>
      )}
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {sortByTitle && items.sort((a,b) => a.title > b.title ? 1 : -1).map(item => <MenuItem component={MenuLink} to={item.to} key={item.id} onClick={handleClose}>{item.title}</MenuItem>)}
        {!sortByTitle && items.map(item => <MenuItem component={MenuLink} to={item.to} key={item.id} onClick={handleClose}>{item.title}</MenuItem>)}
      </Menu>
    </React.Fragment>
  );
}

export default function AdminAppBar() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isAdmin = window.isAdmin;
  const isCouple = window.isCouple;
  const isLimitedAdmin = window.isLimitedAdmin;
  const isOfficiant = window.isOfficiant;

  const userRoles = {
    'admin': isAdmin,
    'limitedAdmin': isLimitedAdmin,
    'officiant': isOfficiant,
    'couple': isCouple,
  };

  const preventDefault = event => event.preventDefault();
  const MenuLink = React.forwardRef((props, ref) => <RouterLink onClick={preventDefault} innerRef={ref} {...props} />);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const history = useHistory();

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = event => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLogoutClick = () => {
    const form = document.getElementById('logout-form');
    form.submit();
    handleMenuClose();
    <Redirect to="/" />
  }

  const handleProfileClick = () => {
    handleMenuClose();
    history.push('/admin/profile');
  }

  const filterByRole = (items, userRoles) => {
    return items.filter(x => {
      if (x.allowedRoles == undefined) {
        /* if no allowedRoles specify, assume you must be an admin */
        return userRoles.admin;
      }
      return x.allowedRoles.some(role => userRoles[role]);
    });
  }

  const officiantsMenuItems = [
    { id: 'officiants-1', title: 'Availability', to: '/admin/officiants/availability', allowedRoles: ['admin', 'officiant'] },
    { id: 'officiants-2', title: 'Events', to: '/admin/officiants/events', allowedRoles: ['admin'] },
  ];

  const adminMenuItems = [
    { id: 'admins-1', title: 'Leads', to: '/admin/leads', allowedRoles: ['admin', 'limitedAdmin'] },
    { id: 'admins-2', title: 'Invoices', to: '/admin/invoices' },
    { id: 'admins-3', title: 'Payments', to: '/admin/payments' },
    { id: 'admins-4', title: 'Couple Balances', to: '/admin/balances' },
    { id: 'admins-5', title: 'Email Tracking', to: '/admin/emails' },
    { id: 'admins-6', title: 'Email Templates', to: '/admin/email-templates' },
    { id: 'admins-7', title: 'Users', to: '/admin/users' },
    { id: 'admins-8', title: 'Templates', to: '/admin/templates' },
    { id: 'admins-9', title: 'Templates List', to: '/admin/templates-list' },
    { id: 'admins-10', title: 'Wedding Planners', to: '/admin/wedding-planners' },
    { id: 'admins-11', title: 'Activity Log', to: '/admin/activity' },
    { id: 'admins-12', title: 'Text Messaging', to: '/admin/sms' },
  ];

  const reportsMenuItems = [
    { id: 'reports-1', title: 'Referrals', to: '/admin/reports/referrals' },
    { id: 'reports-2', title: 'Rehearsals', to: '/admin/reports/rehearsals' },
    { id: 'reports-3', title: 'Second Meetings', to: '/admin/reports/second-meetings' },
    { id: 'reports-4', title: 'Rehearsals and Meetings', to: '/admin/reports/rehearsals-meetings' },
    { id: 'reports-5', title: 'Officiant Weddings', to: '/admin/reports/officiant-weddings' },
    { id: 'reports-6', title: 'Officiant Weddings Search', to: '/admin/reports/officiant-weddings-search' },
    { id: 'reports-7', title: 'Upcoming Weddings', to: '/admin/reports/upcoming-weddings' },
    { id: 'reports-8', title: 'Cancelled Weddings', to: '/admin/reports/cancelled-weddings' },
    { id: 'reports-9', title: 'Past Weddings', to: '/admin/reports/past-weddings' },
    { id: 'reports-10', title: 'Venues', to: '/admin/reports/venues' },
    { id: 'reports-11', title: 'Officiants', to: '/admin/reports/officiants' },
    { id: 'reports-12', title: 'Booked and Complete Weddings', to: '/admin/reports/booked-complete' },
    { id: 'reports-13', title: 'Venues and Balance', to: '/admin/reports/venue-balances' },
    { id: 'reports-14', title: 'Inquiry Source', to: '/admin/reports/inquiry-source' },
    { id: 'reports-15', title: 'Wedding Show Bookings (Regional)', to: '/admin/reports/wedding-shows-by-region' },
    { id: 'reports-16', title: 'Wedding Show Bookings', to: '/admin/reports/wedding-shows' },
    { id: 'reports-17', title: 'Placeholder Couples', to: '/admin/reports/placeholder-couples' },
    { id: 'reports-18', title: 'Packages', to: '/admin/reports/packages' },
    { id: 'reports-19', title: 'Weddings Booked By Date', to: '/admin/reports/weddings-booked-by-date' },
    { id: 'reports-20', title: 'Bookings By Price', to: '/admin/reports/bookings-by-price-point' },
    { id: 'reports-21', title: 'Wedding Team', to: '/admin/reports/wedding-team' },
    { id: 'reports-22', title: 'Referral Vendors', to: '/admin/reports/weddings' },
  ];

  const menuId = 'primary-search-account-menu';

  const profileMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
      <Box py={1}>
        <Divider />
      </Box>
      {isCouple &&
        <div>
          <MenuItem>
            <Link href="/couple" color="inherit" underline="none">Couple Home</Link>
          </MenuItem>
          <Box py={1}>
            <Divider />
          </Box>
        </div>
      }
      <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const mobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem component={MenuLink} to="/admin" onClick={handleMobileMenuClose}>
        <IconButton color="inherit">
            <PeopleIcon />
        </IconButton>
        <span>Couples</span>
      </MenuItem>
      {(isAdmin || isOfficiant) && (
        <MenuItem>
          <AppBarMenuItem
            menuId="officiants-menu"
            buttonTitle="Officiants"
            buttonIcon={<PeopleIcon />}
            items={filterByRole(officiantsMenuItems, userRoles)}
            subMenuClick={handleMobileMenuClose}
          />
        </MenuItem>
      )}
      {(isAdmin || isLimitedAdmin) && (
        <MenuItem>
          <AppBarMenuItem
            menuId="admins-menu"
            buttonTitle="Admin"
            buttonIcon={<PeopleIcon />}
            items={filterByRole(adminMenuItems, userRoles)}
            subMenuClick={handleMobileMenuClose}
          />
        </MenuItem>
      )}
      {isAdmin && (
        <MenuItem>
          <AppBarMenuItem
            menuId="reports-menu"
            buttonTitle="Reports"
            buttonIcon={<AssessmentIcon />}
            items={reportsMenuItems}
            subMenuClick={handleMobileMenuClose}
            sortByTitle={true}
          />
        </MenuItem>
      )}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <span>Profile</span>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="static">
        <Toolbar>
          <Typography className={classes.title} variant="h6" noWrap>
            Enduring Promises
          </Typography>
          <div className={classes.sectionDesktop}>
            <div className={classes.desktopMenuLeft}>
              <Button component={MenuLink} color="inherit" className={classes.link} to="/admin">
                Couples
              </Button>
              {(isAdmin || isOfficiant) && <AppBarMenuItem
                menuId="officiants-menu"
                buttonTitle="Officiants"
                items={filterByRole(officiantsMenuItems, userRoles)}
              />}
              {(isAdmin || isLimitedAdmin) && <AppBarMenuItem
                menuId="admins-menu"
                buttonTitle="Admin"
                items={filterByRole(adminMenuItems, userRoles)}
              />}
              {isAdmin && <AppBarMenuItem
                menuId="reports-menu"
                buttonTitle="Reports"
                items={reportsMenuItems}
                sortByTitle={true}
              />}
            </div>
          </div>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              style={{marginRight: -1}}
            >
              <AccountCircle />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {mobileMenu}
      {profileMenu}
    </div>
  );
}
